import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

import { HEADER_HEIGHT, HEADER_HEIGHT_MOBILE } from '@/config';
import { useWindowSize } from '@/hooks';

const DESKTOP_WIDTH = 1024;

/*  -> showStickyHeader scrolling under ref */
export const useStickyHeader = (): {
  ref: (node?: Element | null) => void;
  showStickyHeader: boolean;
  isTopbarHidden: boolean;
  stickyHeaderWidth: number;
} => {
  const windowSize = useWindowSize();

  const isTopbarHidden = windowSize.width ? windowSize.width >= DESKTOP_WIDTH : false;

  const { entry, inView, ref } = useInView({
    rootMargin: `-${isTopbarHidden ? HEADER_HEIGHT : HEADER_HEIGHT_MOBILE}px`,
    initialInView: true,
  });

  const refElement = entry?.target as HTMLDivElement;

  const [showStickyHeader, setShowStickyHeader] = useState(false);
  const [stickyHeaderWidth, setStickyHeaderWidth] = useState(0);

  useEffect(() => {
    setShowStickyHeader(!inView);
    setStickyHeaderWidth(refElement?.offsetWidth);
  }, [inView, refElement, windowSize.width]);

  return { ref, showStickyHeader, isTopbarHidden, stickyHeaderWidth };
};
